<template>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M62.9958 48.687C64.3347 47.3499 64.3347 45.182 62.9958 43.8449L34.4244 15.313C33.0855 13.976 30.9146 13.976 29.5757 15.313L1.00422 43.8449C-0.33474 45.182 -0.33474 47.3499 1.00422 48.687C2.34316 50.024 4.51401 50.024 5.85296 48.687L32.0001 22.5761L58.1472 48.687C59.4861 50.024 61.6569 50.024 62.9958 48.687Z"
  />
</template>
